export const isValid = (
    value,
    validType,
    required = false
) => {
    if (!required) {
        if (value === "" || !validType) return "";
    }
    if ((required && value === "") || !validType) {
        switch (validType) {
            case "israeliId":
            case "id":
                return `נדרש להזין מספר ת"ז`;
            case "passport":
                return "נדרש להזין מספר דרכון";
            case "cellPhone":
            case "phone":
                return "* נדרש להזין טלפון ";
            case "email":
                return "נדרש להזין אי-מייל";
            case "firstName":
            case "lastName":
                return validType === "firstName"
                    ? "נדרש להזין שם פרטי"
                    : "נדרש להזין שם משפחה";
            default:
        }
    }
    switch (validType) {
        case "israeliId":
            // Israeli id: 9 digits with a check digit (weights 1/2, digits over 9 reduced).
            return isValidIsraeliId(value) ? "" : "מספר ת\"ז לא תקין";
        case "id":
            return /^\d{9}$/.test(value) ? "" : "מספר ת\"ז לא תקין";
        case "passport":
            return /^[A-Za-z0-9]{9}$/.test(value) ? "" : "מספר דרכון לא תקין";
        case "cellPhone":
            return /^05\d([-]{0,1})\d{7}$/.test(value) ||
                /^0\d([-]{0,1})\d{7}$/.test(value)
                ? ""
                : "מספר טלפון לא תקין";
        case "oneTo99":
            return +value <= 99 && +value >= 1 ? "" : "נא הכנס מספר בין 1 ל-99";
        case "email":
            return /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(
                value
            )
                ? ""
                : "דוא\"ל לא תקין";
        case "firstName":
        case "lastName":
            return /^[a-zA-Z\s \u0590-\u05fe]{2,20}$/.test(value)
                ? ""
                : validType === "firstName"
                    ? "שם פרטי לא תקין"
                    : "שם משפחה לא תקין";
        case "isEnglish":
            return /^[a-zA-Z0-9!@#\$%\^\&*]+$/.test(value) ? "" : "אנגלית בלבד";
        case "password":
            return /(?=[A-Za-z0-9@#$%^&+!=]+$)^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,}).{8,20}$/.test(
                value
            )
                ? ""
                : "error";
        case "address":
            return /^[a-zA-Z0-9\s \u0590-\u05fe]{2,}$/.test(value)
                ? ""
                : "כתובת לא תקינה";
        case "mobileOnly":
            return /^05\d([-]{0,1})\d{7}$/.test(value)
                ? ""
                : "מספר טלפון לא תקין";
        default:
            return "";
    }
};

export const passwordVerifecator = (
    password,
    rulesConfig
) => {
    if (password) {
        const newUIRules = rulesConfig.map((rule) => {
            return {
                ...rule,
                isActive: false,
            };
        });

        // length
        if (password.length >= 8 && password.length < 20) {
            newUIRules[0].isActive = true;
        }

        // Only English letters (upper and lower case) and numbers
        if (/^[a-zA-Z0-9!@#\$%\^\&*]+$/.test(password)) {
            newUIRules[1].isActive = true;
        }

        // at least 1 uppercase letter
        if (/[A-Z]/.test(password)) {
            newUIRules[2].isActive = true;
        }

        // at least 1 lowercase letter
        if (/[a-z]/.test(password)) {
            newUIRules[3].isActive = true;
        }

        // at least 1 number
        if (/\d/.test(password)) {
            newUIRules[4].isActive = true;
        }

        newUIRules[5].isActive = true;

        // Does not have the same letter 3 times in a row
        if (!/(.)\1\1/.test(password)) {
            newUIRules[6].isActive = true;
        }

        return newUIRules;
    }
    return rulesConfig.map((rule) => {
        return {
            ...rule,
            isActive: false,
        };
    });
};
export const isValidIsraeliId = (value) => {
    const id = String(value ?? "").trim();
    if (!/^\d{1,9}$/.test(id)) {
        return false;
    }

    if (Number(id) === 0) {
        return false;
    }

    const padded = id.padStart(9, "0");
    const sum = padded.split("").reduce((total, digit, index) => {
        const product = Number(digit) * ((index % 2) + 1);

        return total + (product > 9 ? product - 9 : product);
    }, 0);

    return sum % 10 === 0;
};
